import React, { useEffect, useState, useContext } from 'react';
import { useSwipeable } from 'react-swipeable';
import globalContext from '../../context/GlobalContext';
import ClientAccess from '../../dataAccess/ClientAccess';
import {
  Body1400N,
  MONTH_SELECTOR_FRONT_ICON, MONTH_SELECTOR_ICON, TextRegularS,
} from '../../utilities/generatedClasses';
import JotformAccess from '../../dataAccess/JotformAccess';
import EmptyState from '../../components/EmptyState';
import LogoContainer from '../../components/header/LogoContainer';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const SetUpUser = (props) => {
  const context = useContext(globalContext);
  const [loading, setLoading] = useState(true);
  const [userSetup, setUserSetup] = useState(null);
  const [isDismissed, dismiss] = useState(false);

  const [startIndex, setStartedIndex] = useState(0);
  const [numberOfItems, setNumberOfItems] = useState(3);
  
  const [minIndex, setMinIndex] = useState(0);
  const navigate = useNavigate();
  const getUserSetup = () => {
    ClientAccess.getUserSetup().then((response) => {
      if (response && response.data.length > 0) {
        const data = response.data[0];
        //window.clientId = data.ClientId;
        if (data) {
          if (data.FinishedProfile === '0') {
            if (props && props.location && props.location.state && props.location.state.submissionCompleted) {
             //setFinishedProfile(true);
             setStartedIndex(1);
            } else {
            setStartedIndex(0);
            }
          } else if (data.SubmittedPayment === '0') {
            setStartedIndex(1);
            setMinIndex(1);

          } else if (data.AddedClient === '0') {
            setStartedIndex(2);
            setMinIndex(2);

          } else {
            setStartedIndex(0);
            goToClientList();
          }
        }

        setUserSetup(data);
        setTimeout(() => {
          setLoading(false);
        }, 200);
      }
    });
  };

  useEffect(() => {
    getUserSetup();
  }, []);

  const finishProfile = () => {
    if (userSetup && userSetup.FinishedProfile === '0') {
      JotformAccess.getJotformToken().then((response) => {
        if (response && response.data) {
          const token = response.data;
          navigate('/home/editprofile', { profileUrl: `${window.jotformUrl}?userToken=${token}` });
        }
      });
    }
  };


  const handlers = useSwipeable({
    onSwipedLeft: () => {
      if (startIndex !== 1) {
        setStartedIndex(startIndex + 1);
      }
    },
    onSwipedRight: () => {
      if (startIndex > minIndex) {
        setStartedIndex(startIndex - 1);
      }
    },
    swipeDuration: 200,
    preventScrollOnSwipe: true,
    trackMouse: true
  });

  const GoToPaySubscription = () => {
    dismiss(false);
    // incrementStartIndex();
  };

  const goToClientList = () => {
    navigate('/home/clientlist');
  };

  const goToClientListPage = () => {
    navigate('/home/clientlist');
  };

  const goBack = () => {
    if (startIndex > minIndex) {
      setStartedIndex(startIndex - 1);
    }
  };

  const goNext = () => {
    // if (startIndex < 2) {
    //   setStartedIndex(startIndex + 1);
    // }

    if (startIndex < 2) {
      setStartedIndex(startIndex + 1);
    }
  };

  return (
    <>
      {loading === true
        && (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%'}}>
               <img className="logo-loader logo-loader--pulse" src="/logo2.svg" alt="Loading" />

          </div>

        )}
{loading === false
        && (
        <div style={{ display: 'flex', flexDirection: 'column', rowGap: '4rem' }} {...handlers}>
          <LogoContainer title="Set Up" />
          <EmptyState
            title="Get Connected"
            body1="To fully experience Prism please:"
            />
          <div style={{
            display: 'flex', width: '30wh', margin: 'auto', flexDirection: 'column', rowGap: '1.5rem', minWidth: '250px'
          }}>
            {startIndex === 0 && userSetup
              && (
              <Button
                variant="contained"
                color="primary"
                size="large"
                style={{
                  background: userSetup.FinishedProfile === '1' ? 'gray' : '#00458f',
                  opacity: userSetup.FinishedProfile === '1'? 0.5 : 1
                }}
                onClick={() => finishProfile()}>
                <div className="WhiteBtnTitleColor">Finish Profile</div>
              </Button>
              )
            }

            {startIndex === 1 && userSetup
              && (
                <div>
                  {userSetup.ApprovedProvider === '0' && !isDismissed
                      && (
                      <div className="wait-approval-toast-card" style={{ marginTop: 0 }}>
                        <p className={Body1400N}>
                          Please wait for Triskele to approve your profile. You will receive an email when you can continue Prism set up!
                        </p>
                        <div style={{ textAlign: 'right' }}>
                          <Button className={TextRegularS} onClick={() => dismiss(true)}>
                            Dismiss
                          </Button>
                        </div>

                      </div>
                      )
                  }
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    style={{
                      background: userSetup.ApprovedProvider === '0' ? 'gray' : '#00458f',
                      opacity: userSetup.ApprovedProvider === '0' ? 0.5 : 1
                    }}
                    onClick={() => GoToPaySubscription()}>
                    <div className="WhiteBtnTitleColor">Pay Subscription</div>
                  </Button>
                </div>

              )
            }

            {startIndex === 2 && userSetup
              && (
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  style={{
                    background: '#00458f'
                  }}
                  onClick={() => goToClientList()}>
                  <div className="WhiteBtnTitleColor">Connect Client(s)</div>
                </Button>
              )
            }


          </div>

          <div className="dot-skip-container">
            <div
              className={MONTH_SELECTOR_ICON}
              aria-hidden
              onClick={() => goBack()}
              style={{
                width: '30px', height: '30px', marginRight: '30px', opacity: startIndex === 0 ? 0.2 : 1,
                pointerEvents: startIndex <= minIndex ? 'none' : 'auto'
              }} />
            <ul className="js_dots dots text-primary">
              <li className={startIndex === 0 ? 'active' : ''} />
              {
                numberOfItems > 1
                && <li className={startIndex === 1 ? 'active' : ''} />
              }
              {
                numberOfItems > 2
                && <li className={startIndex === 2 ? 'active' : ''} />
              }
            </ul>
            <div
              className={MONTH_SELECTOR_FRONT_ICON}
              aria-hidden
              onClick={() => goNext()}
              style={{
                marginLeft: '30px',
                width: '30px',
                height: '30px',
                opacity: startIndex === 2 || (userSetup && userSetup.ApprovedProvider === '0' && startIndex === 1) ? 0.2 : 1
              }} />

            {/* <label aria-hidden onClick={() => goToDashboard()} className={Body2400U}>Skip</label> */}
          </div>

        </div>
        )}
    </>
    
  );
};

export default SetUpUser;
